// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MdRMx","rootNoMargin":"styles_rootNoMargin__2KnK4"};